@if ((isVersionCheckInProgress$ | async) === false) {
  <router-outlet></router-outlet>
}
@if ((isVersionCheckInProgress$ | async) || (isLoadingNavigation$ | async)) {
  <flexyoo-loader></flexyoo-loader>
}
